import React from 'react';

const CookieBanner = () => {
  React.useEffect(() => {
    const head = document.getElementsByTagName('html')[0];
    // const language = getCurrentLanguage();
    const language = "fr";
    const cookieBotScript = document.createElement('script');
    const cookieBot = document.getElementById('Cookiebot');
    if (cookieBot !== undefined && cookieBot !== null) {
      cookieBot.remove();
    }
    cookieBotScript.setAttribute('id', 'Cookiebot2');
    cookieBotScript.async = true;
    cookieBotScript.setAttribute('data-culture', language);
    cookieBotScript.setAttribute(
      'data-cbid',
      '7b25bcec-9649-425e-9b45-fccae787c9d0'
    );
    cookieBotScript.src = 'https://consent.cookiebot.com/uc.js';
    head.appendChild(cookieBotScript);
    return () => {
      head.removeChild(cookieBotScript);
    };
  }, []);

  return <></>;
};

export default CookieBanner;
